import React, { useEffect, useState } from "react";
import * as dates from "date-fns";
import { compose } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ReactEcharts from "echarts-for-react"; 

import {
  Grid,
  Box,
  TextField,
} from "@material-ui/core";

import { withTitle, withAuth } from "../../HoC";

import StyledStats from "./Statistics.style";

// import { Chart } from "./Chart";

// import { createMock, createDates, createStatisticsMock } from "./mock";
// import { parseWeeks } from "./helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
 
// CSS Modules, react-datepicker-cssmodules.css// 
import 'react-datepicker/dist/react-datepicker-cssmodules.css';

import { getRequest, getRequestParams } from "../../services/Requests";
import { Footer } from "../../Components/Footer/Footer";
import { socketReducer } from "../../services/socketService/reducer";
import { socketManager } from "../../services/socketService/socketManager";
import { generateUniqueId } from "../../utils/uuid4";

class IStatisticsData {
  currentCapacity: string [];
  date: string [];
  max: string [];

  constructor( currentCapacity: string[], date: string[], max: string[]) {
    this.currentCapacity = currentCapacity;
    this.date = date;
    this.max = max;
  }
}

const Statistics = (props) => {

  const {
    devices = [],
    socketReducer,
  } = props;

  const eChartsRef = React.useRef(null);

  let date:string[] = []
  let currentCapacity:string[] = []
  let maxCapacity:string[] = []
  let isLoading = true;
  let interval;
  
  const selectedDevice = devices.find((e) => e.uuid === props.match.params.deviceId);

  if (!selectedDevice) {
    props.history.push("/admin");
    return null;
  }

  if (selectedDevice.statisticsActive === 0) {
    return (<Redirect to="/error" />);
  }

  // const [statisticsData, setStatisticsData] = useState<{data: any, category: any}>({
  //   data: [],
  //   category: []
  // })
  // var [ stateToExecAfterLoading, setStateToExecAfterLoading] = useState(true);

  // const updateStatisticsData = (p: any, q: any) => setStatisticsData((statisticsData) => {
  //   console.log(p,q);
  //   return {
  //     data: q,
  //     category: p
  //   }
  // })
  
  const {
    isConnected,
    counter = 0,
    capacity,
    isInTimeout = false,
    maxReached = false,
    queue = [],
  } = socketReducer;
  
  const {
    name = "",
    id: deviceId,
    bookingActivated = 0,
  } = selectedDevice || {};

  const randomId = generateUniqueId();

  const [ selectedDate, setDate ] = useState<{ start: any, end: any}>({
    start: new Date(),
    end: new Date(),
  });
  const updateDate = (p: any) => setDate((selectedDate: any) => {
    return {
      start: p.start ,
      end: p.end,
    }
  });

  const onDateChange = (key: "start" | "end") => (ev) => {
    
    clearInterval(interval);
    if (key == "start"){
      var Difference_In_Time = (new Date(selectedDate.end.getFullYear(), selectedDate.end.getMonth(), selectedDate.end.getDate(), 0, 0, 0).getTime() + ( 3600 * 1000 * 24)) - new Date(ev.target.value).getTime();
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      if (new Date(ev.target.value) > selectedDate.end)
        updateDate({start: new Date(ev.target.value), end: new Date(ev.target.value)})
      else 
        if (Difference_In_Days > 30)
          updateDate({start: new Date(ev.target.value), end: dates.addMonths(new Date(ev.target.value),1)})
        else
          updateDate({start: new Date(ev.target.value), end: selectedDate.end})
    }
    else{
      updateDate({start: selectedDate.start, end: new Date(ev.target.value)})
    }
    date = []
    currentCapacity = []
    maxCapacity = []
   // updateStatistics();
  };

  var option = {
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      data: date
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: currentCapacity,
        type: 'bar',
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(180, 180, 180, 0.2)'
        },
        emphasis: {
          focus: 'series'
        }
      },
      {
        data: maxCapacity,
        type: 'bar',
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(80, 80, 80, 0.2)'
        },
        emphasis: {
          focus: 'series'
        }
      }
    ]
  }; 

  const updateStatistics = async () => {
    console.log(selectedDate.start,selectedDate.end);
    const result = await getRequestParams<any>({
      url: `statistics/${props.match.params.deviceId}`,
      params: {
        startDate: selectedDate.start, //dates.format(selectedDate.start, "yyyy-MM-dd"),
        endDate: selectedDate.end //dates.format(selectedDate.end, "yyyy-MM-dd")
      }
    });
    let ResultData :IStatisticsData = result.data;

    date = [];
    currentCapacity = [];
    maxCapacity = [];
    date = ResultData.date;
    currentCapacity = ResultData.currentCapacity;
    maxCapacity = ResultData.max;
    
    var option = {
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        type: 'category',
        data: date
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: currentCapacity,
          type: 'bar',
          showBackground: true,
          backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)'
          },
          emphasis: {
            focus: 'series'
          }
        },
        {
          data: maxCapacity,
          type: 'bar',
          showBackground: true,
          backgroundStyle: {
            color: 'rgba(80, 80, 80, 0.2)'
          },
          emphasis: {
            focus: 'series'
          }
        }
      ]
    }; 

    // updateStatisticsData( date, currentCapacity);
    //console.log(result)
    //console.log(statisticsData.data);
    //console.log(option);
    eChartsRef.current?.getEchartsInstance().setOption(option);
    //setStateToExecAfterLoading(false);
  }
  useEffect(() => {
    updateStatistics();
    return () => {
    };
  }, [selectedDate]);
  
  useEffect(() => {
    socketManager.init({ deviceId, uid: randomId});
    return () => socketManager.close();
  }, []);

  //  useEffect(() => {
  //   const interval = setInterval(async () => {
  //     updateStatistics();
  //   }, 30000);
  //    return () => {
  //    };
  //  });

  return (<StyledStats>
    <Grid direction="column" justifyContent="center" alignItems="center" container style={{ background: "white" }} >
      <Grid item className="grid-item filter" xs={12}>
        <Box justifyContent="center" alignItems="center" flexDirection="row">
          <div className="input-group">
            <label> Inizio </label>
            <TextField
              onChange={onDateChange("start")}
              value={dates.format(selectedDate.start, "yyyy-MM-dd")}
              type="date"
            />
          </div>
          <div className="input-group">
            <label> Fine </label>
            <TextField
              onChange={onDateChange("end")}
              value={dates.format(selectedDate.end, "yyyy-MM-dd")}
              inputProps={{
                max: dates.format(dates.addMonths(selectedDate.start, 1), "yyyy-MM-dd"),
                min: dates.format(selectedDate.start, "yyyy-MM-dd"),
              }}
              type="date"
            />
          </div>
          {/* <div className="input-group">
            <button onClick={updateStatistics()}>Aggiorna</button>
          </div> */}
        </Box>
      </Grid>
      <Grid item className="grid-item" xs={12} >
        <ReactEcharts ref={eChartsRef} option={option} style={{ background: "white" }}/>
      </Grid>
      <Grid item className="grid-item chart" xs={12}>
        <Box p={2} style={{ background: "white" }} alignItems="flex-start">
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            <div style={{ width: 10, height: 10, background: "#5470C6" }} />
            <p style={{ marginLeft: 10 }}> Persone entrate </p>
          </div>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            <div style={{ width: 10, height: 10, background: "#91CC75" }} />
            <p style={{ marginLeft: 10 }}> Persone contemporanee</p>
          </div>
        </Box>
      </Grid>
    </Grid>
    <Footer isConnected={isConnected} />
  </StyledStats>);
};

const mapStateToProps = (state: any) => ({
  controllerReducer: state.controllerReducer,
  devices: state.adminReducer.devices,
  socketReducer: state.socketReducer,
});

export default compose(
  withTitle("Stats"),
  withAuth(0),
  connect(mapStateToProps),
)(Statistics);
